export default __webpack_public_path__ + "static/media/search.3447dcb6.svg";